import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import UserGroups from "./userGroups";
import Forms from "./forms";

const feature = "userGroups";

const InitialState = Record({
  forms: new Forms(),
  userGroups: new UserGroups()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function UserGroupsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.userGroups
    ) {
      state = state.updateIn(["userGroups", "entities"], map =>
        map.mergeDeep(action.payload.entities.userGroups));
    }
  }

  switch (action.type) {
    case actions.GET_USER_GROUPS: {
      return state.setIn(["userGroups", "loading"], true);
    }
    case actions.GET_USER_GROUPS_SUCCESS: {
      state = state.deleteIn(["userGroups", "entities"]);
      state = state.deleteIn(["userGroups", "results"]);
      state = state.setIn(
        ["userGroups", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["userGroups", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["userGroups", "entities"], map =>
        map.mergeDeep(action.payload.entities.userGroups));
      state = state.setIn(
        ["userGroups", "results"],
        action.payload.result.userGroups
      );
      return state.setIn(["userGroups", "loading"], false);
    }
    case actions.GET_USER_GROUPS_ERROR: {
      return state.setIn(["userGroups", "loading"], false);
    }

    case actions.GET_USER_GROUP: {
      return state.setIn(["userGroups", "loading"], true);
    }
    case actions.GET_USER_GROUP_SUCCESS: {
      return state.setIn(["userGroups", "loading"], false);
    }
    case actions.GET_USER_GROUP_ERROR: {
      return state.setIn(["userGroups", "loading"], false);
    }

    case actions.POST_USER_GROUPS: {
      return disableForm(state, "createUserGroup");
    }
    case actions.POST_USER_GROUPS_SUCCESS: {
      state = clearForm(state, "createUserGroup", Forms);
      return enableForm(state, "createUserGroup");
    }
    case actions.POST_USER_GROUPS_ERROR: {
      state = enableForm(state, "createUserGroup");
      return setFormErrors(state, "createUserGroup", action.payload.errors);
    }

    case actions.PATCH_USER_GROUP: {
      return state.setIn(["userGroups", "loading"], true);
    }
    case actions.PATCH_USER_GROUP_SUCCESS: {
      return state.setIn(["userGroups", "loading"], false);
    }
    case actions.PATCH_USER_GROUP_ERROR: {
      return state.setIn(["userGroups", "loading"], false);
    }

    case actions.DELETE_USER_GROUP: {
      return state.deleteIn(["userGroups", "entities", action.payload.uid]);
    }

  }

  return entitiesReducer(formsReducer(state, feature, action), feature, action);
}



// WEBPACK FOOTER //
// ./src/common/userGroups/reducer.js